import { render } from "./LineButton.vue?vue&type=template&id=1bad710e&scoped=true"
import script from "./LineButton.vue?vue&type=script&lang=js"
export * from "./LineButton.vue?vue&type=script&lang=js"

import "./LineButton.vue?vue&type=style&index=0&id=1bad710e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bad710e"

export default script